$('.product-slider').slick({
  dots: false,
  arrows: false,
  infinite: true,
  speed: 2500,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        
      }
    },
    {
      breakpoint: 768,
      settings: {
        
      }
    },
  ]
});

$('.feedback-slider').slick({
  dots: false,
  arrows: true,
  infinite: true,
  // speed: 2500,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToScroll: 1,
        slidesToShow: 2,
      }
    },
    {
      breakpoint:480,
      settings: {
        slidesToScroll: 1,
        slidesToShow: 1,
      }
    },
  ]
});
$(function() {
  
  var marquee = $('.marquee');
  var ul = $('.marquee ul');
  
  var cloneContent = function() {

    var doClone = true;
    var clone_ul = function () {
       ul.find('li').clone().appendTo( ul );
    }
    var check_ul_width = function() {
      if(marquee.width() > ul.width() ) {
        clone_ul();
        return;
      }
      doClone = false;
      ul.css('visibility', 'visible');
    }

    do {
      check_ul_width();
      var mw = marquee.width();
      var uw = ul.width();
    } while (doClone);

  }

  cloneContent();
  
   
function initializeMarquee() {
    const isMobile = window.innerWidth <= 767;

    $('.marquee').marquee('destroy'); // Destroy any existing instance
    $('.marquee').marquee({
        duration: isMobile ? 10000 : 30000,
        duplicated: true,
    });
}

$(document).ready(function () {
    initializeMarquee();

    // Reinitialize on window resize
    $(window).on('resize', function () {
        initializeMarquee();
    });
});

  
});
